import { render } from "./Page4.vue?vue&type=template&id=4f860163&scoped=true"
import script from "./Page4.vue?vue&type=script&lang=js"
export * from "./Page4.vue?vue&type=script&lang=js"

import "./Page4.vue?vue&type=style&index=0&id=4f860163&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f860163"]])

export default __exports__